import { getOfflineCustomers, setOfflineCustomers } from '@/forage/shared/customers'
import axios from 'axios'
import misc from '@/mixins/misc'

const CustomerService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the cluster to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    if (navigator.onLine) {
      return axios.get('rsm/customers', { params }).then(
        response => {
          if (misc.methods.isMobile()) {
            setOfflineCustomers(response.data.items)
          }
          return response
        }
      )
    }

    const { items, total_rows } = await getOfflineCustomers(params)

    return {
      data: {
        current_page: params?.page || 1,
        items: items,
        per_page: params?.per_page || 10,
        total_rows: total_rows
      }
    }
  },

  async reports (params = {}) {
    return axios.get('rsm/reports/field-officers/customers', { params })
  },

  async exports (params = {}) {
    return axios.get('rsm/exports/field-officers/customers', { params })
  },

  async show (id) {
    return axios.get(`rsm/customers/${id}`)
  },

  async post (payload = {}) {
    return axios.post('rsm/customers', payload)
  },

  async put (params = { id: '' }) {
    return axios.put(`rsm/customers/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rsm/customers/${data.id}`, { data })
  }
}

export default CustomerService
